import type { RoundClock } from "@cwb/protocol";

/**
 * Whole simulated seconds left, rounded up so a new run shows 07:00 and the
 * final partial second stays visible until the authoritative ending tick.
 */
export function roundSecondsRemaining(
  clock: RoundClock | null,
  tickRateHz: number,
  ended = false,
): number {
  if (!clock || ended || tickRateHz <= 0) return 0;
  return Math.max(0, Math.ceil(clock.remainingTicks / tickRateHz));
}
